import React from "react";

export default function BreathingCircle({ size = 220, label = "Breathe" }) {
  return (
    <div className="relative flex items-center justify-center shrink-0" style={{ width: size, height: size }}>
      {/* Outer multi-color halo */}
      <div
        className="absolute inset-0 rounded-full bps-breathing"
        style={{
          background:
            "radial-gradient(circle at 50% 45%, rgba(34,211,238,0.55) 0%, rgba(168,85,247,0.28) 40%, rgba(245,158,11,0.14) 62%, transparent 75%)",
        }}
      />
      {/* Concentric glowing rings */}
      <div
        className="absolute rounded-full border-2 bps-breathing"
        style={{ width: size * 0.92, height: size * 0.92, borderColor: "rgba(168,85,247,0.35)", boxShadow: "0 0 24px rgba(168,85,247,0.35)" }}
      />
      <div
        className="absolute rounded-full border-2"
        style={{ width: size * 0.78, height: size * 0.78, borderColor: "rgba(34,211,238,0.45)", boxShadow: "0 0 22px rgba(34,211,238,0.45)" }}
      />
      <div
        className="absolute rounded-full border"
        style={{ width: size * 0.64, height: size * 0.64, borderColor: "rgba(245,158,11,0.4)", boxShadow: "0 0 18px rgba(245,158,11,0.3)" }}
      />
      {/* Inner luminous core — iridescent */}
      <div
        className="absolute rounded-full bps-breathing bps-pulse-glow"
        style={{
          width: size * 0.5,
          height: size * 0.5,
          background:
            "radial-gradient(circle at 38% 32%, rgba(255,255,255,0.95) 0%, rgba(34,211,238,0.85) 35%, rgba(168,85,247,0.7) 70%, rgba(245,158,11,0.5) 100%)",
          border: "1px solid rgba(255,255,255,0.3)",
          boxShadow: "0 0 40px rgba(34,211,238,0.6), inset 0 0 24px rgba(255,255,255,0.25)",
        }}
      />
      {label && (
        <span className="relative font-mono text-[11px] tracking-[0.32em] uppercase text-white/90">
          {label}
        </span>
      )}
    </div>
  );
}
